import { Plan, PlanStep, PlanStepLink } from '@core/models/plan.model';
import { createAction, props } from '@ngrx/store';
import { ErrorDetail } from 'src/app/utils/errors.model';

const loadStepsAndLinks = createAction('[Plan] Load steps and links by plan id', props<{ id?: number }>());
const stepsAndLinksLoaded = createAction('[Plan] Steps and links loaded', props<{
  plan: Partial<Plan>; steps: PlanStep[]; links: PlanStepLink[];
}>());

const save = createAction('[Plan] Save', props<{ plan: Partial<Plan> }>());
const saved = createAction('[Plan] Saved', props<{ plan: Plan }>());
const remove = createAction('[Plan] Remove', props<{ id: number }>());
const removed = createAction('[Plan] Removed');

const addStep = createAction('[Plan] Add step', props<{ step: Partial<PlanStep> }>());
const stepAdded = createAction('[Plan] Step added', props<{ step: PlanStep }>());
const updateStep = createAction('[Plan] Update step', props<{ step: Partial<PlanStep> }>());
const stepUpdated = createAction('[Plan] Step updated', props<{ step: PlanStep }>());
const stepSaveFailed = createAction('[Plan] Step save failed', props<{ step: Partial<PlanStep>; errors: ErrorDetail[] }>());

const moveStep = createAction('[Plan] Move graph node of step', props<{ step: PlanStep }>());
const stepMoved = createAction('[Plan] Graph node of step moved', props<{ step: PlanStep }>());
const deleteStep = createAction('[Plan] Delete step', props<{ id: number }>());
const stepDeleted = createAction('[Plan] Step deleted', props<{ id: number }>());

const addLink = createAction('[Plan] Add link', props<{ link: PlanStepLink }>());
const addLinkFailed = createAction('[Plan] Add link failed', props<{ link: PlanStepLink; errors: ErrorDetail[] }>());
const linkAdded = createAction('[Plan] Link added', props<{ link: PlanStepLink }>());
const deleteLink = createAction('[Plan] Delete link', props<{ parentId: number; childId: number }>());
const linkDeleted = createAction('[Plan] Link deleted', props<{ parentId: number; childId: number }>());

export const planActions = {
  loadStepsAndLinks,
  stepsAndLinksLoaded,

  save,
  saved,
  remove,
  removed,

  addStep,
  stepAdded,
  updateStep,
  stepUpdated,
  stepSaveFailed,

  moveStep,
  stepMoved,

  deleteStep,
  stepDeleted,

  addLink,
  linkAdded,
  addLinkFailed,
  deleteLink,
  linkDeleted
};
